import React from 'react';
import * as S from './styles';
import {
  Users,
  Building2,
  Box,
  FileText,
  Truck,
  Search,
  RefreshCw,
  LogIn,
  DollarSign,
  UserCogIcon,
} from 'lucide-react';

interface IDashboardItem {
  title: string;
  icon: string;
  path: string;
  isActive: boolean;
  iconReact?: boolean;
}

const iconMap: Record<string, React.ElementType> = {
  storefront: UserCogIcon,
  groups: Users,
  box: Box,
  paper: FileText,
  truck: Truck,
  search: Search,
  refresh: RefreshCw,
  logs: LogIn,
  money: DollarSign,
};

export const DashboardItem: React.FC<IDashboardItem> = ({
  title,
  icon,
  path,
  isActive,
  iconReact,
}) => {
  const IconComponent = iconMap[icon];

  return (
    <S.Content
      href={isActive ? path : '#'}
      className={isActive ? '' : 'inactive'}
    >
      {iconReact && IconComponent ? (
        <IconComponent
          size={25}
          strokeWidth={2}
          color={'#f15a31'}
          style={{ marginBottom: '5px', marginTop: '3px' }}
        />
      ) : (
        <S.Image
          src={require(`../../assets/dashboard-icons/${icon}.png`)}
          alt={icon}
        />
      )}
      <S.Text>{title}</S.Text>
    </S.Content>
  );
};
